import {
    FormHelperText,
    MenuItem,
    Select,
    styled,
} from '@mui/material';
import type { FieldAttributes } from 'formik';
import {
    Field,
    useField,
} from 'formik';
import React from 'react';
import { v4 as uuid } from 'uuid';

import { COLOUR_LIST } from '../constants/AiappConstants';

const StyledFormHelperText = styled(FormHelperText)({ color: '#ff8484' });

const ColorDropdownField: React.FC<FieldAttributes<{}>> = ({ ...props }) => {
    const [ field, meta ] = useField<{}>(props);
    const colorList = COLOUR_LIST;
    const errorText = meta.error && meta.touched ? meta.error : '';

    return (
        <>
            <Field
                {...field}
                type='select'
                as={Select}
                error={!!errorText}
                labelId="color-label">
                {colorList.map((color: string) => (
                    <MenuItem
                        key={uuid()}
                        value={color}>
                        {color}
                    </MenuItem>
                ))}
            </Field>
            {errorText ? <StyledFormHelperText>
                {errorText}
            </StyledFormHelperText> : null}
        </>
    );
};

export default ColorDropdownField;
